import React, { createContext, useState, useCallback, ReactNode } from 'react';
import { AlertModal } from '@/components/ui/Modal';

interface AlertDialogOptions {
  title: string;
  message: string;
  type?: 'info' | 'success' | 'warning' | 'danger';
  buttonText?: string;
}

interface AlertDialogContextType {
  showAlert: (options: AlertDialogOptions) => void;
}

export const AlertDialogContext = createContext<AlertDialogContextType | undefined>(undefined);

export const AlertDialogProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [options, setOptions] = useState<AlertDialogOptions>({
    title: '',
    message: '',
    type: 'info',
    buttonText: 'OK',
  });

  const showAlert = useCallback((alertOptions: AlertDialogOptions) => {
    setOptions({
      title: alertOptions.title,
      message: alertOptions.message,
      type: alertOptions.type ?? 'info',
      buttonText: alertOptions.buttonText ?? 'OK',
    });
    setIsOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <AlertDialogContext.Provider value={{ showAlert }}>
      {children}
      <AlertModal
        isOpen={isOpen}
        onClose={handleClose}
        title={options.title}
        message={options.message}
        type={options.type}
        buttonText={options.buttonText}
      />
    </AlertDialogContext.Provider>
  );
};
